import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import OneSignalReact from 'react-onesignal';

import { ErrorBoundary } from '@safelyq/base-feature';
import PageTitleContext from 'contexts/PageTitleContext';
import ScrollToTop from 'components/ScrollToTop';
import Routes from 'routes';
import { oneSignalAppId } from 'services/prefix-holder';
import OpenInAppModel from 'routes/UserRoutes/OpenInAppModel';

import 'bulma.css';
import 'bootstrap.grid.css';

console.disableYellowBox = true;

console.warn = () => { };
console.error = () => { };

const App = () => {
  const [pageTitle, setPageTitle] = useState('');

  // Initialize OneSignalReact and set up notification listeners
  useEffect(() => {
    const initializeOneSignal = async () => {
      try {
        console.log('Initializing OneSignalReact...');
        OneSignalReact.init({ appId: oneSignalAppId });
        OneSignalReact.showSlidedownPrompt();

        console.log('OneSignalReact initialized successfully.');
      } catch (error) {
        console.error('Error initializing OneSignalReact:', error);
      }
    };

    initializeOneSignal();
  }, []);

  // Shows a cookie banner, Blocks cookies until consent, Remembers whether a user accepted or rejected cookies.
  useEffect(() => {
    if (window.location.hostname !== 'localhost') {
      const script = document.createElement('script');
      script.id = 'cookieyes';
      script.src = 'https://cdn-cookieyes.com/client_data/6c61cb2cdc2257f305eaea5e/script.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <ErrorBoundary>
      <Helmet>
        <title>ChatCLB</title>
        <meta name='description' content='ChatCLB, a IT Best Solutions INC subsidiary, was formed to help business, hospitals, counties, cities, large  gatherings of any kind to manage people traffic in and out of facilities open or closed.' />
        <meta name='keywords' content='Appointments, ChatCLB Appointment, Online Appointments, Queueing System, Le Bernardin Appointment, Dallas City Hall' />
      </Helmet>
      <PageTitleContext.Provider value={{ pageTitle, setPageTitle }}>

        {/* Removed <BrowserRouter>.
            NOTE: the <BrowserRouter> lives in src/index.js (it wraps <AuthGate>).
            Do not add another router here, otherwise /authentication/callback is
            routed twice and falls through to the catch-all NotFound route. */}
        <ScrollToTop />
        {/* Ask user to open in the mobile app */}
        <OpenInAppModel />
        <Routes />
      </PageTitleContext.Provider>
    </ErrorBoundary>
  );
};

export default App;
